import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Switch, Route, Redirect } from 'react-router'

import PrivateRoute from '@components/PrivateRoute'

import Login from '@pages/Login'
import Valuation from '@pages/Valuation'
import ValuationReport from '@pages/ValuationReport'
import Historic from '@pages/Historic'

import { manageTooltips } from '@services/tooltip'

import { Main } from './styles'

const App = () => {
  useEffect(manageTooltips)

  return (
    <Main>
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" component={Login} />
          <PrivateRoute exact path="/avaliacao" component={Valuation} />
          <PrivateRoute exact path="/historico" component={Historic} />
          <Route
            exact
            path="/relatorio-avaliacao/:valuationId"
            component={ValuationReport}
          />
          <Redirect to="/login" />
        </Switch>
      </BrowserRouter>
    </Main>
  )
}

export default App
